import { GET_INVOICE_COLLECTION_SUCCESS, GET_MONTHLY_SYSTEM_STATISTIC_SUCCESS, GET_SYSTEM_STATISTIC_SUCCESS, GET_MONTHLY_PAYABLE_RECON_SUCCESS } from "../../actions/types";

const INITIAL_STATE = {
    // The systemStatistic object is for the Weekly Revenue
    systemStatistic: {},
    invoiceCollection: {},
    // The monthlySystemStatistic object is for the Monthly Revenue
    monthlySystemStatistic: {},
    monthlyPayableRecon: {}
};

export default (state = INITIAL_STATE, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_SYSTEM_STATISTIC_SUCCESS:
            return { ...state, systemStatistic: payload };
        case GET_INVOICE_COLLECTION_SUCCESS: 
            return { ...state, invoiceCollection: payload }
        case GET_MONTHLY_SYSTEM_STATISTIC_SUCCESS:
            return { ...state, monthlySystemStatistic: payload }
        case GET_MONTHLY_PAYABLE_RECON_SUCCESS: 
            return { ...state, monthlyPayableRecon: payload }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/billingDashboard/BillingDashboardReducer.js